export function $articleType(s: string): string {
    return (
        {
            standard: "Zubehör",
            cannabis: "Blüten",
            readymade: "Readymade",
            milled: "Milled",
            smalls: "Smalls",
            essence: "Extrakte",
            xtracts: "Xtract",
            merch: "Merch",
        }[s] ?? "Sonstiges"
    )
}

